module.exports = __webpack_public_path__ + "img/pt-1.21537393.jpg";